import { ReactNode, type FC } from "react";
import { Flex } from "@chakra-ui/react";
import { useIsMobile } from "~/hooks/useIsMobile";
import { Trans } from "~/utils/i18next";
import { NavItemWrapper } from "./NavItemWrapper";

type Who = "crew" | "conceive";

interface Props {
  left?: ReactNode;
  link: string | null;
  onClick: () => void;
  who: Who;
}

export const MessageNavItem: FC<Props> = ({ left, link, onClick, who }) => {
  const isMobile = useIsMobile();

  if (!link) return null;

  if (!isMobile) return null;

  const handleClick = () => {
    onClick();
    window.open(link, "_blank");
  };

  return (
    <Flex align="center">
      {left}
      <NavItemWrapper onClick={handleClick}>
        <Trans i18nKey={`navigation.message.${who}`} />
      </NavItemWrapper>
    </Flex>
  );
};
